import { useRef as O, useState as te, useEffect as ne, useCallback as re, cloneElement as ge, useContext as Ge, createContext as Ie } from "react";
import { c as U } from "./clamp-CqQfNxSP.js";
import { h as se, i as G, u as ze, l as ae, j as i, B as $, m as we, q as ke, n as xe, G as Ae } from "./UnstyledButton-ujNMaBde.js";
import { a as be, O as oe, g as Pe, c as Be } from "./CloseButton-Bp_UJ8Gq.js";
import { q as Te, s as Ee, r as Xe, j as Me, l as De, t as Ye, u as qe, v as Ue, w as $e, x as He, y as _e, z as Je, D as Ke, E as Ve, H as Ze, J as fe, K as Qe, L as ee, M as We, T as me, N as he } from "./Button-CMUmoC07.js";
import { u as eo } from "./DirectionProvider-DtCDJ2BX.js";
import { g as oo } from "./get-style-object-D6lVXaRM.js";
function Po(e) {
  return {
    x: U(e.x, 0, 1),
    y: U(e.y, 0, 1)
  };
}
function To(e, o, t = "ltr") {
  const a = O(!1), l = O(!1), u = O(0), [p, v] = te(!1), f = O(null);
  return ne(() => {
    a.current = !0;
  }, []), { ref: re(
    (n) => {
      if (f.current && (f.current(), f.current = null), !n)
        return;
      const w = ({ x: r, y: P }) => {
        cancelAnimationFrame(u.current), u.current = requestAnimationFrame(() => {
          if (a.current && n) {
            n.style.userSelect = "none";
            const g = n.getBoundingClientRect();
            if (g.width && g.height) {
              const D = U((r - g.left) / g.width, 0, 1);
              e({
                x: t === "ltr" ? D : 1 - D,
                y: U((P - g.top) / g.height, 0, 1)
              });
            }
          }
        });
      }, x = () => {
        document.addEventListener("mousemove", h), document.addEventListener("mouseup", c), document.addEventListener("touchmove", b, { passive: !1 }), document.addEventListener("touchend", c);
      }, E = () => {
        document.removeEventListener("mousemove", h), document.removeEventListener("mouseup", c), document.removeEventListener("touchmove", b), document.removeEventListener("touchend", c);
      }, y = () => {
        !l.current && a.current && (l.current = !0, typeof o?.onScrubStart == "function" && o.onScrubStart(), v(!0), x());
      }, c = () => {
        l.current && a.current && (l.current = !1, v(!1), E(), setTimeout(() => {
          typeof o?.onScrubEnd == "function" && o.onScrubEnd();
        }, 0));
      }, d = (r) => {
        y(), r.preventDefault(), h(r);
      }, h = (r) => w({ x: r.clientX, y: r.clientY }), M = (r) => {
        r.cancelable && r.preventDefault(), y(), b(r);
      }, b = (r) => {
        r.cancelable && r.preventDefault(), w({ x: r.changedTouches[0].clientX, y: r.changedTouches[0].clientY });
      };
      n.addEventListener("mousedown", d), n.addEventListener("touchstart", M, { passive: !1 }), f.current = () => {
        n.removeEventListener("mousedown", d), n.removeEventListener("touchstart", M);
      };
    },
    [t, e]
  ), active: p };
}
const to = {
  duration: 100,
  transition: "fade"
};
function ve(e, o) {
  return { ...to, ...o, ...e };
}
var H = { tooltip: "m_1b3c8819", arrow: "m_f898399f" };
function no({
  offset: e,
  position: o,
  defaultOpened: t
}) {
  const [a, l] = te(t), u = O(null), { x: p, y: v, elements: f, refs: m, update: n, placement: w } = Te({
    placement: o,
    middleware: [
      Ee({
        crossAxis: !0,
        padding: 5,
        rootBoundary: "document"
      })
    ]
  }), x = w.includes("right") ? e : o.includes("left") ? e * -1 : 0, E = w.includes("bottom") ? e : o.includes("top") ? e * -1 : 0, y = re(
    ({ clientX: c, clientY: d }) => {
      m.setPositionReference({
        getBoundingClientRect() {
          return {
            width: 0,
            height: 0,
            x: c,
            y: d,
            left: c + x,
            top: d + E,
            right: c,
            bottom: d
          };
        }
      });
    },
    [f.reference]
  );
  return ne(() => {
    if (m.floating.current) {
      const c = u.current;
      c.addEventListener("mousemove", y);
      const d = Xe(m.floating.current);
      return d.forEach((h) => {
        h.addEventListener("scroll", n);
      }), () => {
        c.removeEventListener("mousemove", y), d.forEach((h) => {
          h.removeEventListener("scroll", n);
        });
      };
    }
  }, [f.reference, m.floating.current, n, y, a]), { handleMouseMove: y, x: p, y: v, opened: a, setOpened: l, boundaryRef: u, floating: m.setFloating };
}
const ro = {
  refProp: "ref",
  withinPortal: !0,
  offset: 10,
  position: "right",
  zIndex: Pe("popover")
}, so = we((e, { radius: o, color: t }) => ({
  tooltip: {
    "--tooltip-radius": o === void 0 ? void 0 : xe(o),
    "--tooltip-bg": t ? ke(t, e) : void 0,
    "--tooltip-color": t ? "var(--mantine-color-white)" : void 0
  }
})), ie = se((e, o) => {
  const t = G("TooltipFloating", ro, e), {
    children: a,
    refProp: l,
    withinPortal: u,
    style: p,
    className: v,
    classNames: f,
    styles: m,
    unstyled: n,
    radius: w,
    color: x,
    label: E,
    offset: y,
    position: c,
    multiline: d,
    zIndex: h,
    disabled: M,
    defaultOpened: b,
    variant: r,
    vars: P,
    portalProps: g,
    attributes: D,
    ...I
  } = t, C = ze(), z = ae({
    name: "TooltipFloating",
    props: t,
    classes: H,
    className: v,
    style: p,
    classNames: f,
    styles: m,
    unstyled: n,
    attributes: D,
    rootSelector: "tooltip",
    vars: P,
    varsResolver: so
  }), { handleMouseMove: k, x: A, y: N, opened: B, boundaryRef: J, floating: K, setOpened: X } = no({
    offset: y,
    position: c,
    defaultOpened: b
  }), F = Me(a);
  if (!F)
    throw new Error(
      "[@mantine/core] Tooltip.Floating component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
    );
  const V = be(J, De(F), o), L = F.props, Y = (R) => {
    L.onMouseEnter?.(R), k(R), X(!0);
  }, Z = (R) => {
    L.onMouseLeave?.(R), X(!1);
  };
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(oe, { ...g, withinPortal: u, children: /* @__PURE__ */ i.jsx(
      $,
      {
        ...I,
        ...z("tooltip", {
          style: {
            ...oo(p, C),
            zIndex: h,
            display: !M && B ? "block" : "none",
            top: (N && Math.round(N)) ?? "",
            left: (A && Math.round(A)) ?? ""
          }
        }),
        variant: r,
        ref: K,
        mod: { multiline: d },
        children: E
      }
    ) }),
    ge(F, {
      ...L,
      [l]: V,
      onMouseEnter: Y,
      onMouseLeave: Z
    })
  ] });
});
ie.classes = H;
ie.displayName = "@mantine/core/TooltipFloating";
const Re = Ie(!1), ao = Re.Provider, io = () => Ge(Re), lo = {
  openDelay: 0,
  closeDelay: 0
};
function le(e) {
  const { openDelay: o, closeDelay: t, children: a } = G("TooltipGroup", lo, e);
  return /* @__PURE__ */ i.jsx(ao, { value: !0, children: /* @__PURE__ */ i.jsx(Ye, { delay: { open: o, close: t }, children: a }) });
}
le.displayName = "@mantine/core/TooltipGroup";
le.extend = (e) => e;
function co(e) {
  if (e === void 0)
    return { shift: !0, flip: !0 };
  const o = { ...e };
  return e.shift === void 0 && (o.shift = !0), e.flip === void 0 && (o.flip = !0), o;
}
function uo(e) {
  const o = co(e.middlewares), t = [Ze(e.offset)];
  return o.shift && t.push(
    Ee(
      typeof o.shift == "boolean" ? { padding: 8 } : { padding: 8, ...o.shift }
    )
  ), o.flip && t.push(
    typeof o.flip == "boolean" ? fe() : fe(o.flip)
  ), t.push(Qe({ element: e.arrowRef, padding: e.arrowOffset })), o.inline ? t.push(
    typeof o.inline == "boolean" ? ee() : ee(o.inline)
  ) : e.inline && t.push(ee()), t;
}
function po(e) {
  const [o, t] = te(e.defaultOpened), l = typeof e.opened == "boolean" ? e.opened : o, u = io(), p = qe(), v = re(
    (P) => {
      t(P), P && h(p);
    },
    [p]
  ), {
    x: f,
    y: m,
    context: n,
    refs: w,
    placement: x,
    middlewareData: { arrow: { x: E, y } = {} }
  } = Te({
    strategy: e.strategy,
    placement: e.position,
    open: l,
    onOpenChange: v,
    middleware: uo(e),
    whileElementsMounted: Ue
  }), { delay: c, currentId: d, setCurrentId: h } = $e(n, { id: p }), { getReferenceProps: M, getFloatingProps: b } = He([
    _e(n, {
      enabled: e.events?.hover,
      delay: u ? c : { open: e.openDelay, close: e.closeDelay },
      mouseOnly: !e.events?.touch
    }),
    Je(n, { enabled: e.events?.focus, visibleOnly: !0 }),
    Ke(n, { role: "tooltip" }),
    // Cannot be used with controlled tooltip, page jumps
    Ve(n, { enabled: typeof e.opened > "u" })
  ]);
  Be(() => {
    e.onPositionChange?.(x);
  }, [x]);
  const r = l && d && d !== p;
  return {
    x: f,
    y: m,
    arrowX: E,
    arrowY: y,
    reference: w.setReference,
    floating: w.setFloating,
    getFloatingProps: b,
    getReferenceProps: M,
    isGroupPhase: r,
    opened: l,
    placement: x
  };
}
const ye = {
  position: "top",
  refProp: "ref",
  withinPortal: !0,
  arrowSize: 4,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  offset: 5,
  transitionProps: { duration: 100, transition: "fade" },
  events: { hover: !0, focus: !1, touch: !1 },
  zIndex: Pe("popover"),
  positionDependencies: [],
  middlewares: { flip: !0, shift: !0, inline: !1 }
}, fo = we(
  (e, { radius: o, color: t, variant: a, autoContrast: l }) => {
    const u = e.variantColorResolver({
      theme: e,
      color: t || e.primaryColor,
      autoContrast: l,
      variant: a || "filled"
    });
    return {
      tooltip: {
        "--tooltip-radius": o === void 0 ? void 0 : xe(o),
        "--tooltip-bg": t ? u.background : void 0,
        "--tooltip-color": t ? u.color : void 0
      }
    };
  }
), _ = se((e, o) => {
  const t = G("Tooltip", ye, e), {
    children: a,
    position: l,
    refProp: u,
    label: p,
    openDelay: v,
    closeDelay: f,
    onPositionChange: m,
    opened: n,
    defaultOpened: w,
    withinPortal: x,
    radius: E,
    color: y,
    classNames: c,
    styles: d,
    unstyled: h,
    style: M,
    className: b,
    withArrow: r,
    arrowSize: P,
    arrowOffset: g,
    arrowRadius: D,
    arrowPosition: I,
    offset: C,
    transitionProps: z,
    multiline: k,
    events: A,
    zIndex: N,
    disabled: B,
    // Scheduled for removal in 9.0
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    positionDependencies: J,
    onClick: K,
    onMouseEnter: X,
    onMouseLeave: F,
    inline: V,
    variant: L,
    keepMounted: Y,
    vars: Z,
    portalProps: R,
    mod: ce,
    floatingStrategy: Q,
    middlewares: Le,
    autoContrast: mo,
    attributes: je,
    target: T,
    ...ue
  } = G("Tooltip", ye, t), { dir: Oe } = eo(), W = O(null), s = po({
    position: We(Oe, l),
    closeDelay: f,
    openDelay: v,
    onPositionChange: m,
    opened: n,
    defaultOpened: w,
    events: A,
    arrowRef: W,
    arrowOffset: g,
    offset: typeof C == "number" ? C + (r ? P / 2 : 0) : C,
    positionDependencies: [...J, T ?? a],
    inline: V,
    strategy: Q,
    middlewares: Le
  });
  ne(() => {
    const S = T instanceof HTMLElement ? T : typeof T == "string" ? document.querySelector(T) : T?.current || null;
    S && s.reference(S);
  }, [T, s]);
  const j = ae({
    name: "Tooltip",
    props: t,
    classes: H,
    className: b,
    style: M,
    classNames: c,
    styles: d,
    unstyled: h,
    attributes: je,
    rootSelector: "tooltip",
    vars: Z,
    varsResolver: fo
  }), q = Me(a);
  if (!T && !q)
    throw new Error(
      "[@mantine/core] Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
    );
  if (T) {
    const S = ve(z, { duration: 100, transition: "fade" });
    return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(oe, { ...R, withinPortal: x, children: /* @__PURE__ */ i.jsx(
      me,
      {
        ...S,
        keepMounted: Y,
        mounted: !B && !!s.opened,
        duration: s.isGroupPhase ? 10 : S.duration,
        children: (Ne) => /* @__PURE__ */ i.jsxs(
          $,
          {
            ...ue,
            "data-fixed": Q === "fixed" || void 0,
            variant: L,
            mod: [{ multiline: k }, ce],
            ...s.getFloatingProps({
              ref: s.floating,
              className: j("tooltip").className,
              style: {
                ...j("tooltip").style,
                ...Ne,
                zIndex: N,
                top: s.y ?? 0,
                left: s.x ?? 0
              }
            }),
            children: [
              p,
              /* @__PURE__ */ i.jsx(
                he,
                {
                  ref: W,
                  arrowX: s.arrowX,
                  arrowY: s.arrowY,
                  visible: r,
                  position: s.placement,
                  arrowSize: P,
                  arrowOffset: g,
                  arrowRadius: D,
                  arrowPosition: I,
                  ...j("arrow")
                }
              )
            ]
          }
        )
      }
    ) }) });
  }
  const pe = q.props, Ce = be(s.reference, De(q), o), de = ve(z, { duration: 100, transition: "fade" });
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(oe, { ...R, withinPortal: x, children: /* @__PURE__ */ i.jsx(
      me,
      {
        ...de,
        keepMounted: Y,
        mounted: !B && !!s.opened,
        duration: s.isGroupPhase ? 10 : de.duration,
        children: (S) => /* @__PURE__ */ i.jsxs(
          $,
          {
            ...ue,
            "data-fixed": Q === "fixed" || void 0,
            variant: L,
            mod: [{ multiline: k }, ce],
            ...s.getFloatingProps({
              ref: s.floating,
              className: j("tooltip").className,
              style: {
                ...j("tooltip").style,
                ...S,
                zIndex: N,
                top: s.y ?? 0,
                left: s.x ?? 0
              }
            }),
            children: [
              p,
              /* @__PURE__ */ i.jsx(
                he,
                {
                  ref: W,
                  arrowX: s.arrowX,
                  arrowY: s.arrowY,
                  visible: r,
                  position: s.placement,
                  arrowSize: P,
                  arrowOffset: g,
                  arrowRadius: D,
                  arrowPosition: I,
                  ...j("arrow")
                }
              )
            ]
          }
        )
      }
    ) }),
    ge(
      q,
      s.getReferenceProps({
        onClick: K,
        onMouseEnter: X,
        onMouseLeave: F,
        onMouseMove: t.onMouseMove,
        onPointerDown: t.onPointerDown,
        onPointerEnter: t.onPointerEnter,
        ...pe,
        className: Ae(b, pe.className),
        [u]: Ce
      })
    )
  ] });
});
_.classes = H;
_.displayName = "@mantine/core/Tooltip";
_.Floating = ie;
_.Group = le;
var Se = { root: "m_d08caa0" };
const Fe = se((e, o) => {
  const t = G("Typography", null, e), { classNames: a, className: l, style: u, styles: p, unstyled: v, attributes: f, ...m } = t, n = ae({
    name: "Typography",
    classes: Se,
    props: t,
    className: l,
    style: u,
    classNames: a,
    styles: p,
    unstyled: v,
    attributes: f
  });
  return /* @__PURE__ */ i.jsx($, { ref: o, ...n("root"), ...m });
});
Fe.classes = Se;
Fe.displayName = "@mantine/core/Typography";
export {
  Fe as T,
  _ as a,
  Po as c,
  To as u
};
